import { AppButton, AppSelectBox } from 'components';
import ChapterSearch from 'components/molecules/ChapterSearch';
import CoursesSearch from 'components/molecules/CoursesSearch';
import {
  AppModal,
  AppModalBody,
  // AppModalFooter,
  AppModalHeader,
} from 'components/molecules/Modal/AppModal';
import QuizSearch from 'components/molecules/QuizSearch';
import useQuizClone from 'hooks/API/POST/useQuizClone';
import useToaster from 'hooks/useToaster';
// import useToaster from 'hooks/useToaster';
import { memo, useState } from 'react';
import ESTDropDownType1 from 'components/molecules/ESTDropDownType1';
import ESDropDown from 'components/molecules/ESDropDown';
import ESClassDropDown from 'components/molecules/ESClassDropDown';
import { keyMapper } from '.';
import { MdOutlineContentCopy } from 'react-icons/md';

function CopyContentsModal({ open, closeModal, data = {}, handleClone }) {
  const {
    classID,
    courseID,
    quizId,
    isAssess,
    isPerform,
    isFromQuestions,
    questionId,
    quizFormat,
  } = data;
  const { args = {} } = data;

  const [courseInfo, setCourseInfo] = useState(Object.assign({}, initialState));
  const [courses, setCourses] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [quizzes, setQuizzes] = useState([]);
  const [papers, setPapers] = useState();
  const [section, setSection] = useState();
  const [copiedAs, setCopyAs] = useState();

  const { isLoading, mutate, isError } = useQuizClone({ courseID });

  useToaster(isLoading, { type: isError ? 'error' : 'success' });

  function clearArray() {
    setCourses([]);
    setChapters([]);
    setQuizzes([]);
  }

  function setLabelsForKeyMapper(key) {
    let labelValue = 'Quiz';
    switch (key) {
      case 'qb':
        labelValue = 'Question Bank';
        break;

      case 'mock':
        labelValue = 'Mock';
        break;

      case 'ncert':
        labelValue = 'Ncert';
        break;
      case 'previous_year':
        labelValue = 'Previous Year';
        break;
      case 'past_papers':
        labelValue = 'Past Papers';
        break;
      default:
        labelValue = 'NA';
        break;
    }
    return labelValue;
  }

  function handleInfoChange(data = {}) {
    setCourseInfo((x) => ({ ...x, ...data }));
    clearArray();
  }

  const allCourses = !Object.values(courseInfo).some((x) => x);

  return (
    <AppModal open={open} closeModal={closeModal} size="md">
      <AppModalHeader>Copy Quiz</AppModalHeader>
      <AppModalBody classNames="p-4">
        <div className="row mb-4">
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESTDropDownType1
              enableAPI
              value={courseInfo.est}
              handleChange={(event) => {
                const est = event.target.value;
                setCourseInfo((x) => ({ ...initialState, est }));
                clearArray();
              }}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESDropDown
              enableAPI={!!courseInfo.est}
              dependencies={{
                query: courseInfo.est ? `est=${courseInfo.est}` : ``,
              }}
              value={courseInfo.es}
              handleChange={(event) => {
                const es = event.target.value;
                handleInfoChange({ es, classId: '' });
              }}
              defaultLook={false}
            />
          </div>
          <div className="col-lg-4 col-md-4 col-sm-4">
            <ESClassDropDown
              enableAPI={!!courseInfo.es}
              dependencies={{
                query: `esId=${courseInfo.es}`,
              }}
              value={courseInfo.classId}
              handleChange={(event) => {
                const classId = event.target.value;
                handleInfoChange({ classId });
              }}
              defaultLook={false}
            />
          </div>
        </div>
        <CoursesSearch
          enableAPI
          dependencies={{
            query: {
              allCourses,
              esId: courseInfo.es,
              estId: courseInfo.est,
              classId: courseInfo.classId,
            },
          }}
          values={courses}
          handleChange={(data = []) => {
            setCourses(data);
          }}
        />
        {/* {isAssess && ( */}
        <div className="my-4">
          <ChapterSearch
            enableAPI={courses.length > 0}
            dependencies={{
              query: {
                esId: courseInfo.es,
                estId: courseInfo.est,
                classId: courseInfo.classId || 'all',
              },
              classID: courseInfo.classId || 'all',
              courseID: courses[0]?._id,
            }}
            values={chapters}
            handleChange={(data) => {
              setChapters(data);
              ['mock', 'past_papers'].includes(copiedAs) && setCopyAs('');
            }}
          />
        </div>
        {/* )} */}
        {isFromQuestions && (
          <QuizSearch
            enableAPI={courses.length > 0}
            dependencies={{
              query: {
                courseID: courses[0]?._id,
                chapterID: chapters[0]?._id || undefined,
              },
              classID,
              courseID: courses[0]?._id,
              chapterID: chapters[0]?._id,
            }}
            values={quizzes}
            handleChange={(data) => {
              setQuizzes(data);
            }}
          />
        )}
        {!isFromQuestions &&
          keyMapper &&
          Object.keys(keyMapper).length > 0 &&
          Object.keys(keyMapper).map((key, i) => {
            return (
              <div className="w-100 mt-4">
                <input
                  type="radio"
                  key={i}
                  value={key}
                  checked={key === copiedAs}
                  name="copyAs"
                  id={setLabelsForKeyMapper(key)}
                  disabled={
                    (['mock', 'previous_year'].includes(key) && chapters.length > 0) ||
                    (!['mock', 'previous_year'].includes(key) && chapters.length <= 0)
                  }
                  onChange={(e) => setCopyAs(e.target.value)}
                />{' '}
                <label htmlFor={setLabelsForKeyMapper(key)}>
                  Copy as {setLabelsForKeyMapper(key)}
                </label>
              </div>
            );
          })}
        {isFromQuestions && quizzes?.[0]?.papers?.length > 0 && (
          <>
            <div className="w-100 mt-4">
              <AppSelectBox
                labelProps={{ label: 'Select paper *' }}
                selectProps={{
                  papers,
                  onChange: (event) => {
                    const paper = event.target.value;
                    setPapers(paper);
                  },
                }}
              >
                <option value="">Choose</option>
                {quizzes?.[0]?.papers?.map?.((option) => {
                  return (
                    <option key={option._id} value={option._id}>
                      {option.value}
                    </option>
                  );
                })}
              </AppSelectBox>
            </div>
          </>
        )}{' '}
        {isFromQuestions && quizzes?.[0]?.sections?.length > 0 && (
          <>
            <div className="w-100 mt-4">
              <AppSelectBox
                labelProps={{ label: 'Select section *' }}
                selectProps={{
                  papers,
                  onChange: (event) => {
                    const paper = event.target.value;
                    setSection(paper);
                  },
                }}
              >
                <option value="">No Section</option>
                {quizzes?.[0]?.sections?.map?.((option) => {
                  return (
                    <option key={option._id} value={option._id}>
                      {option.value}
                    </option>
                  );
                })}
              </AppSelectBox>
            </div>
          </>
        )}
        <div className="d-flex flex-row mt-4 justify-content-center">
          {true && (
            <>
              <AppButton
                type="button"
                variantClass="btn-primary mx-3 d-flex align-items-center"
                style={{ minWidth: '1.5rem' }}
                onClick={() => {
                  if (isFromQuestions) {
                    const qData = {
                      courses: courses.map((x) => x._id),
                      chapters: chapters.map((x) => x._id),
                      quizzes: quizzes.map((x) => x._id),
                      questionId,
                      quizId,
                    };

                    if (qData?.courses?.length === 0) return;
                    // if (qData?.chapters?.length === 0) return;
                    if (qData?.quizzes?.length === 0) return;
                    if (quizzes?.[0]?.papers?.length > 0 && !papers) return;
                    if (quizzes?.[0]?.section?.length > 0 && !section) return;

                    // Assuming one quiz is selected
                    if (quizzes?.[0]?.quizCategory && args)
                      args.goesToQuizCategory = quizzes?.[0]?.quizCategory;

                    if (args) qData.args = args;

                    if (quizzes?.[0]?.papers?.length > 0 && papers) qData.paperId = papers;
                    if (quizzes?.[0]?.sections?.length > 0 && section) qData.sectionId = section;
                    // console.log(
                    //   '🚀 ~ file: CopyContentsModal.js:248 ~ CopyContentsModal ~ qData:',
                    //   qData
                    // );
                    handleClone?.(qData);
                    return;
                  }

                  if (isLoading) return;
                  if (!quizId) return;

                  const apiBody = {
                    courses: courses.map((x) => x._id),
                    quizId,
                    isAssess,
                    isPerform,
                    copiedAs: keyMapper[copiedAs],
                  };

                  if (isAssess) apiBody.chapters = chapters.map((x) => x._id);

                  if (apiBody?.courses?.length === 0) return;
                  if (!copiedAs && isAssess && apiBody?.chapters?.length === 0) return;

                  mutate(apiBody, {
                    onSuccess() {
                      closeModal();
                    },
                  });
                }}
              >
                {isLoading ? 'Copying...' : isFromQuestions ? 'Copy Contents' : 'Copy Contents'}{' '}
                <MdOutlineContentCopy className="ml-1" />
              </AppButton>
            </>
          )}
          <AppButton variantClass="btn-plane p--tint mx-4" onClick={closeModal}>
            Cancel
          </AppButton>
        </div>
      </AppModalBody>
    </AppModal>
  );
}

const initialState = {
  classId: '',
  est: '',
  es: '',
};

export default memo(CopyContentsModal);
